export default {
  all: 'Qualsiasi',
}
